import { Title, Input, Date, Gender, Country } from '@/components/fields';
import { useTheme } from '@/contexts/ThemeContext';

type Props = {
  skipYears?: number;
};

export default function PersonalDetails({
  skipYears = 15,
}: Props): JSX.Element {
  const { landingPage } = useTheme();
  return (
    <>
      <div>
        {landingPage !== 'v12' && landingPage !== 'v13' && (
          <h3 className="bg-box-header text-xl leading-8 font-medium tracking-tight text-white flex items-center mb-5 py-2 px-4">
            Personal Details
          </h3>
        )}
        <div className="px-6 py-1">
          <Title id="title" isRequired>
            Title
          </Title>
          <Gender id="gender" isRequired>
            Gender
          </Gender>
          <Input id="forename" autocomplete="cc-csc" isRequired>
            First Name
          </Input>
          <Input id="surname" autocomplete="cc-csc" isRequired>
            Last Name
          </Input>
          <Input id="middlenames" isRequired={false}>
            Middlenames
          </Input>

          <Input id="mother_maiden_name" isRequired>
            Mother&apos;s Maiden Name (Surname before marriage)
          </Input>
          <Input id="birth_surname" isRequired>
            Birth Last Name
            <br />
            <span className="font-medium text-xs text-red-600">
              Enter your last name as it was when you were born.
            </span>
          </Input>
          <Date id="date_of_birth" isRequired skipYears={skipYears}>
            Date of Birth
          </Date>
          <Input id="place_of_birth" isRequired>
            Place of Birth
            <br />
            <span className="font-medium text-xs text-red-600">
              Enter the town, city, county or region in which you were born.
            </span>
          </Input>
          <Country id="country_of_birth" isRequired>
            Country of Birth
          </Country>
        </div>
      </div>
    </>
  );
}
